module.exports = __webpack_public_path__ + "static/media/banner.97980e83.png";